import { render } from "./CdaContentBody.vue?vue&type=template&id=c9c29558&scoped=true"
import script from "./CdaContentBody.vue?vue&type=script&lang=js"
export * from "./CdaContentBody.vue?vue&type=script&lang=js"

import "./CdaContentBody.vue?vue&type=style&index=0&id=c9c29558&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c29558"]])

export default __exports__